import React from "react";
import { Link } from "react-router-dom";
import { Smartphone, CheckCircle, Zap, Star, ExternalLink } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DeveloppementMobile = () => {
  return (
    <div className="font-sans min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/dev-mobile/654133.png)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black to-flowkraft-primary opacity-90"></div>

        <div className="container mx-auto px-4 relative z-10 py-20">
          <div className="flex items-center justify-center mb-8">
            <Smartphone className="w-16 h-16 text-flowkraft-secondary" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 text-white">
            Développement Mobile
          </h1>
          <p className="text-xl text-center text-gray-200 max-w-3xl mx-auto">
            Applications natives et cross-platform pour iOS et Android
          </p>
        </div>
      </section>

      {/* Description */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Applications Mobiles Sur Mesure
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Nous développons des applications mobiles performantes et intuitives
            qui offrent une expérience utilisateur exceptionnelle sur iOS et
            Android.
          </p>
          <p className="text-lg text-gray-700">
            Notre expertise couvre le développement natif et cross-platform,
            nous permettant de choisir la meilleure approche pour votre projet.
          </p>
        </div>
      </section>

      {/* Approches */}
      {/* <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Approches de Développement
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Zap className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                React Native
              </h3>
              <p className="text-gray-700 mb-4">
                Développement cross-platform avec un seul code source pour iOS
                et Android.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Temps de développement réduit
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Performance proche du natif
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Large écosystème
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Star className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Flutter</h3>
              <p className="text-gray-700 mb-4">
                Framework moderne de Google pour des applications hautement
                performantes.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  UI personnalisable
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Hot reload rapide
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Animations fluides
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Smartphone className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Applications Natives
              </h3>
              <p className="text-gray-700 mb-4">
                Développement natif Swift/Kotlin pour performance maximale.
              </p>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Performance optimale
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Accès complet aux API
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Expérience native parfaite
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section> */}

      {/* Fonctionnalités */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Fonctionnalités Clés
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              "Authentification utilisateur",
              "Notifications push",
              "Géolocalisation",
              "Paiement in-app",
              "Mode hors ligne",
              "Synchronisation cloud",
              "Partage sur réseaux sociaux",
              "Scan QR/Code-barres",
              "Chat en temps réel",
            ].map((feature) => (
              <div
                key={feature}
                className="bg-gray-50 rounded-lg p-6 flex items-center hover:shadow-lg transition-shadow"
              >
                <CheckCircle className="w-6 h-6 text-flowkraft-primary mr-3 flex-shrink-0" />
                <p className="font-semibold text-gray-900">{feature}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Notre Processus
          </h2>
          <div className="space-y-6">
            {[
              {
                title: "Analyse & Conception",
                desc: "Définition des fonctionnalités et design UX/UI",
              },
              {
                title: "Développement",
                desc: "Codage avec méthodologie agile et sprints réguliers",
              },
              {
                title: "Tests",
                desc: "Tests fonctionnels, performance et compatibilité",
              },
              {
                title: "Déploiement",
                desc: "Publication sur App Store et Google Play",
              },
              {
                title: "Maintenance",
                desc: "Support, mises à jour et évolutions",
              },
            ].map((step, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-6 shadow-md flex items-start"
              >
                <div className="bg-flowkraft-primary text-white rounded-full w-10 h-10 flex items-center justify-center font-bold mr-4 flex-shrink-0">
                  {index + 1}
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {step.title}
                  </h3>
                  <p className="text-gray-700">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Réalisations */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Applications Mobiles
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            {/* Projet 1 */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300 border-2 border-gray-100">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-mobile/654133.png"
                  alt="Application de Contrôle Routier"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Contrôle Routier
                </h3>
                <p className="text-gray-600 mb-4">
                  Application mobile professionnelle pour la gestion des
                  contrôles routiers avec rapports en temps réel et
                  synchronisation cloud
                </p>
                {/* <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    React Native
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Firebase
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    Géolocalisation
                  </span>
                </div> */}
              </div>
            </div>

            {/* Projet 2 */}
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-flowkraft-xl transition-shadow duration-300 border-2 border-gray-100">
              <div className="h-48 bg-gradient-to-r from-flowkraft-primary to-flowkraft-secondary flex items-center justify-center overflow-hidden">
                <img
                  src="/images/dev-mobile/miniature.jpeg"
                  alt="Team Shuffle"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Team Shuffle
                </h3>
                <p className="text-gray-600 mb-4">
                  Application pour créer des équipes de football équilibrées de
                  manière aléatoire, avec gestion de joueurs et statistiques
                </p>
                {/* <div className="flex flex-wrap gap-2 mb-4">
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    React
                  </span>
                  <span className="bg-flowkraft-primary bg-opacity-10 text-flowkraft-primary px-3 py-1 rounded-full text-sm font-medium">
                    TypeScript
                  </span>
                </div> */}
                <a
                  href="https://teamshuffle.flowkraftagency.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center text-flowkraft-primary hover:text-flowkraft-secondary font-semibold transition-colors"
                >
                  Voir le projet <ExternalLink className="w-4 h-4 ml-1" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/main/2149755776.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-flowkraft-primary to-black opacity-90"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Transformez votre idée en application mobile
          </h2>
          <p className="text-xl mb-8 text-gray-200">
            Discutons de votre projet d'application mobile
          </p>
          <Link
            to="/#contact"
            className="inline-block bg-white text-flowkraft-primary px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Demander un devis
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default DeveloppementMobile;
